import { IntRange } from '@utils/typescriptGuards';



interface ProgressBarProps {
	label: string,
	progress: IntRange<0,101>
}


export const ProgressBar = (props: ProgressBarProps) => {
	const { label, progress } = props;

	return (
		<div className='component-progress-bar'>

			<span className='progress-label'>{label}</span>
			
			<div className='progress-background'>
				
				<div className='progress-value' style={{ width: `${progress}%` }}>
				</div>

				{progress !== 0 &&
					<div className='progress-text'>{`${Math.round(progress)}%`}</div>}

			</div>
			
		</div>
	);
}